import { render, staticRenderFns } from "./activatePlan.vue?vue&type=template&id=1dc8f0a9&scoped=true"
import script from "./activatePlan.vue?vue&type=script&lang=js"
export * from "./activatePlan.vue?vue&type=script&lang=js"
import style0 from "./activatePlan.vue?vue&type=style&index=0&id=1dc8f0a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8f0a9",
  null
  
)

export default component.exports